module.exports = "/_next/static/images/Alexandrin_Patron-020e2b8f09ac985eb42b90919749b07f.webp";